export const Services = () => {
    return (
        <div className="generic_page">
            <p>Insère tes services ici cher Yotam</p>
        </div>
    )
}